import { gql } from '@apollo/client';

export const fetchRoles = gql`
    query FetchRoles {
    fetchRoles {
        data {
            roles {
                description
                id
                name
                permissions {
                    created_at
                    updated_at
                    id
                    role_id
                    action {
                        id
                        name
                        action
                        created_at
                        updated_at
                        resource {
                            id
                            name
                            menu
                            display
                            created_at
                            updated_at
                            module {
                                id
                                name
                                menu
                                display
                                created_at
                                updated_at
                            }
                        }
                    }
                }
            }
        }
        error {
            field
            message
            code
        }
    }
}
`;


